import {
  all,
  call,
  put,
  race,
  select,
  takeLatest,
  delay,
} from "redux-saga/effects";
import { fromQuery } from "utils/query";
import { getQueryFilterName } from "utils/filter";
import {
  webcodeNoResult,
  webcodeRequested,
  webcodeSkip,
  webcodeSuccess,
} from "actions";
import { APP_INITIALIZE, FORM_SUBMIT, QUERY_CHANGE } from "actions/const";
import { fetchWebcodeTargetUrl } from "services/search/webcode";
import * as selectors from "./selectors";
import config from "config";

export function* requestWebcode(searchTerm = "") {
  const noResultTerm = yield select(selectors.getWebcodeNoResult);

  searchTerm = searchTerm.trim();
  if (!searchTerm.match(/^.[^\s]+$/) || searchTerm === noResultTerm) {
    yield put(webcodeSkip());
    return;
  }

  yield put(webcodeRequested());
  try {
    const webcodeRace = yield race({
      webcode: call(fetchWebcodeTargetUrl, searchTerm),
      webcodeTimeout: delay(config.webcodes.timeout),
    });

    const webcodeUrl = webcodeRace && webcodeRace.webcode;

    if (webcodeUrl) {
      yield put(webcodeSuccess(webcodeUrl));
    } else if ("webcode" in webcodeRace) {
      yield put(webcodeNoResult(searchTerm));
      yield put(webcodeSkip());
    } else {
      yield put(webcodeSkip());
    }
  } catch {
    yield put(webcodeSkip());
  }
}

export function* interceptQueryChange(action) {
  const queryParameters = fromQuery(action.urlSearch);
  const skipWebcode = queryParameters["skipWebcode"];

  if (config.webcodes.enabled && skipWebcode !== "true") {
    const searchTerm =
      action.type === APP_INITIALIZE
        ? queryParameters[getQueryFilterName()]
        : action.value;

    yield requestWebcode(searchTerm);
  } else {
    yield put(webcodeSkip());
  }
}

// watcher
export function* watchWebcode() {
  yield all([
    yield takeLatest(QUERY_CHANGE, interceptQueryChange),
    yield takeLatest(APP_INITIALIZE, interceptQueryChange),
    yield takeLatest(FORM_SUBMIT, interceptQueryChange),
  ]);
}
